import { render, staticRenderFns } from "./EventListAll.vue?vue&type=template&id=61c64f86&"
import script from "./EventListAll.vue?vue&type=script&lang=js&"
export * from "./EventListAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports